import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Hero.css';
import { FaCheckCircle } from 'react-icons/fa';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <div className="hero-section">
      <div className="hero-overlay"></div>
      
      <div className="hero-content">
        <div className="hero-text">
          <h1 className="hero-title">
            Mașini în rate 100%<br />
            online FĂRĂ AVANS
          </h1>

          <div className="hero-benefits">
            <div className="benefit-item">
              <FaCheckCircle className="benefit-icon" />
              <span>Aplici 100% online fără deplasări</span>
            </div>
            <div className="benefit-item">
              <FaCheckCircle className="benefit-icon" />
              <span>Prezentare auto prin video call</span>
            </div>
            <div className="benefit-item">
              <FaCheckCircle className="benefit-icon" />
              <span>Mașini testate cu km 100% reali</span>
            </div>
            <div className="benefit-item">
              <FaCheckCircle className="benefit-icon" />
              <span>Transport Gratuit oriunde în țară</span>
            </div>
          </div>

          <button className="hero-cta-button" onClick={() => navigate('/masini')}>
            <svg 
              width="20" 
              height="20" 
              viewBox="0 0 24 24" 
              fill="none"
              style={{ marginRight: '8px' }}
            >
              <circle cx="11" cy="11" r="8" stroke="currentColor" strokeWidth="2"/>
              <path d="m21 21-4.35-4.35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            Vezi toate mașinile
          </button>
        </div>

        {/* <div className="hero-car-image">
          <img 
            src="https://images.unsplash.com/photo-1503376780353-7e6692767b70?w=800&q=80" 
            alt="Mașină sport roșie" 
            className="hero-car"
          />
        </div> */}
      </div>
    </div>
  );
};

export default Hero;